import React from "react";
import { Box, Container } from "@mui/material";

import Loading from "./Loading";
import axiosInstance from "../actions/AxiosInstance";
import api from "../actions/EndPoints";
import {
  includeQueryParams,
  mgpSsoDevLink,
  NEXT_STEPS_URL
} from "../components/shared/Links";
import ServiceErrorCard from "../components/shared/ServiceErrorCard";
import connectWithUserStore from "../reducers/connectWithUserStore";
import { isJson, log, setLastRequestTime, getSTModalActive } from "../Utils";
import ExistingFPSModal from "../components/modals/ExistingFPSModal";

const styles = {
  wrapper: {
    marginTop: "2%",
    paddingBottom: 20
  },
  iFrame: {
    height: "100%",
    width: "100%",
    border: "none"
  }
};

const Frame = ({ children, style, name, title, src, onLoad }) => {
  return (
    <iframe name={name} style={style} title={title} src={src} onLoad={onLoad}>
      {children}
    </iframe>
  );
};

const Form = React.forwardRef((props, ref) => {
  const { containerURL, message, method, name, id } = props;
  return (
    <form
      ref={ref}
      id={id}
      action={containerURL}
      method={method}
      target="mgp_iframe"
    >
      <input name={name} value={message} type="hidden" />
    </form>
  );
});

const MGPHubContainer = connectWithUserStore(
  ({ state, dispatch, applicationConfig }) => {
    const { wrapper, iFrame } = styles;
    const { ssoData, ssoDataError } = state || {};
    const [mgpHeight, setMgpHeight] = React.useState(null);
    const ref = React.createRef();
    const [mgpFetched, setMgpFetched] = React.useState(false);
    const [mgpError, setMgpError] = React.useState(false);
    const [hideLoader, setHideLoader] = React.useState(false);
    const [dataFetched, setDataFetched] = React.useState(false);
    const [sso, setSSO] = React.useState(null);
    const [message, setMessage] = React.useState(null);
    const [containerURL, setContainerURL] = React.useState(false);
    const [isRASUser, setIsRASUser] = React.useState(false);
    const [userInFPS, setUserInFPS] = React.useState(false);
    const [anonymousUser, setAnonymousUser] = React.useState(false);

    React.useEffect(() => {
      let checkTrue = false;
      let config = {
        method: "post",
        url: api.getSSOAPI,
        headers: {
          apiKey: applicationConfig.apiKey
        }
      };

      async function getAddCoClientSuccessSSO() {
        try {
          const ssoCall = await axiosInstance(config);
          console.log("ssoCall", ssoCall);
          if (ssoCall) {
            const { data } = ssoCall;
            setLastRequestTime();
            if (data !== undefined) {
              console.log("data");
              if (data.existingRASClient) {
                setIsRASUser(true);
              }
              if (data.activeEngagementPlanningServiceClient) {
                console.log("activeEngagementPlanningServiceClient");
                setUserInFPS(true);
              }
              console.log("state", state);
              if (state) {
                // For logged in user
                console.log("logged in user - load iframe");
                dispatch({
                  type: "SSO_DATA",
                  ssoData: data,
                  ssoDataError: false
                });
              } else {
                // For non-logged in user
                console.log("non-loggedIn User load iframe");
                setContainerURL(data.containerURL);
                setAnonymousUser(true);
                setMessage("");
                setSSO(data);
              }
            }
          }
        } catch (err) {
          console.log("err", err);
          setMgpError(true);
          if (getSTModalActive() === "open") {
            setLastRequestTime();
          }
        }
      }
      if (!checkTrue && !dataFetched) {
        console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
        console.log("checkTrue", checkTrue);
        // console.log('ssoData', ssoData);
        setDataFetched(true);
        getAddCoClientSuccessSSO();
      }
      return () => {
        checkTrue = true;
      };
    }, [
      dataFetched,
      dispatch,
      ssoData,
      state,
      isRASUser,
      userInFPS,
      applicationConfig.apiKey
    ]);

    React.useEffect(() => {
      let isCancelled = false;
      if (!isCancelled && ssoData) {
        if (!ssoDataError) {
          setSSO(true);
          setMessage(ssoData && ssoData.message);
          const ssoContainerURL = ssoData && ssoData.containerURL;
          const url = ssoContainerURL || mgpSsoDevLink;
          setContainerURL(url);
          console.log("STATEFUL", ssoData);
        }
      }
      return () => {
        isCancelled = true;
      };
    }, [ssoData, ssoDataError]);

    React.useEffect(() => {
      let isCancelled = true;
      let MGPResponded;
      // To Hide loader when MGP-UI reposne is error screen
      // For now FPS is unable to read this response message / getting any post message from MGP
      const checkIframeResponse = () => {
        if (
          document.getElementsByTagName("iframe").length &&
          document.getElementsByTagName("iframe")[0].offsetHeight === 250
        ) {
          // Timeout to wait for MGP ui to load after response
          setTimeout(() => {
            setHideLoader(true);
          }, 10000);
          clearInterval(MGPResponded);
        }
      };
      if (isCancelled) {
        MGPResponded = setInterval(() => checkIframeResponse(), 10000);
      }
      setTimeout(() => setHideLoader(true), 30000);
      return () => {
        isCancelled = false;
      };
    }, []);

    React.useEffect(() => {
      // When the user attempts to navigate away while the iframe is loaded, show a pop-up asking them to save.
      let isComplete = false;
      const askUserToSaveData = () => e => {
        if (!isComplete) {
          e.preventDefault();
        }
        e.returnValue = "";
      };

      // Remove the listener once we no longer need it.
      const removeDataReminderOnComplete = () => e => {
        if (e.data === "completed") {
          isComplete = true;
        }
      };

      // Only set up these listeners for logged-in users.
      if (window.location.pathname.includes("secure")) {
        window.addEventListener("beforeunload", askUserToSaveData());
        window.addEventListener("message", removeDataReminderOnComplete());
      }

      const getIframeDimensions = () => e => {
        const mgpData = e.data;
        // Reset Session Timer when iframe content / height changes
        if (getSTModalActive() !== "open") {
          setLastRequestTime();
        }
        console.log("getSTModalActive - timer reset");
        console.log(
          "sessionTimerModal - getSTModalActive()",
          getSTModalActive()
        );
        if (mgpData.payload) {
          setHideLoader(true);
        }

        if (e.data && isJson(e.data) && !mgpData.payload) {
          const parsedMgpData = JSON.parse(e.data);
          const iframeHeight = parsedMgpData.contentHeight;
          console.log("parsedMgpData.event", parsedMgpData.event);
          setMgpFetched(true);
          if (
            parsedMgpData.mgpEvent &&
            parsedMgpData.mgpEvent === "MGP_PAGE_LOADED"
          ) {
            console.log("scroll to top ->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
            document.getElementById("iframe-mgp").scrollIntoView();
          }
          if (mgpData !== null) {
            setMgpHeight(iframeHeight);
          }
        }

        console.log("mgpData", mgpData);

        if (mgpData === "completed") {
          localStorage.setItem("RIC", JSON.stringify({ validNS: true }));
          window.location.replace(includeQueryParams(NEXT_STEPS_URL));
        }

        setTimeout(() => {
          setHideLoader(true);
        }, 10000);
      };

      window.addEventListener("message", getIframeDimensions());
      return () => {
        window.removeEventListener("message", getIframeDimensions());
      };
    }, []);

    React.useEffect(() => {
      if (ref.current !== null && !isRASUser && !userInFPS) {
        log(
          console.log(
            "NODELIST",
            document.getElementsByTagName("iframe")[0].chilNodes > 1
          )
        );

        ref.current.submit();
      }
    }, [ref, isRASUser, userInFPS]);
    const iFrameContainerHeight = mgpHeight;

    return (
      <div>
        {(sso === null || iFrameContainerHeight <= 100) &&
          !mgpError &&
          !hideLoader && (
            <Container maxWidth={false}>
              <div style={wrapper}>
                <Loading headerText="Preparing Calculator..." />
              </div>
            </Container>
          )}
        {(sso === null || iFrameContainerHeight <= 100) && mgpError && (
          <Box>
            <ServiceErrorCard />
          </Box>
        )}
        {(isRASUser || userInFPS) && (
          <ExistingFPSModal isRASUser={isRASUser} userInFPS={userInFPS} />
        )}
        {(sso !== null || iFrameContainerHeight > 100) && (
          <div style={{ position: "relative", maxWidth: false }}>
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "40px",
                backgroundColor: "white"
              }}
            />
            <div
              style={{
                height: iFrameContainerHeight,
                width: "100%",
                minHeight: 250
              }}
              id="iframe-mgp"
            >
              {!mgpFetched && (
                <Form
                  ref={ref}
                  id="submitForm"
                  name="SAMLResponse"
                  containerURL={containerURL}
                  message={message}
                  method={anonymousUser ? "get" : "post"}
                />
              )}
              <Frame name="mgp_iframe" style={iFrame} title="mgphub" />
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default function MGPHubView({ applicationConfig }) {
  return <MGPHubContainer applicationConfig={applicationConfig} />;
}
